import $ from 'jquery'
import I18n from 'i18n-js'

// These globals are part of the existing Workplace view contract. Several
// Rails templates and the reCAPTCHA pack use them directly.
window.$ = window.jquery = window.jQuery = $
globalThis.$ = globalThis.jQuery = $
window.I18n = I18n
import $ from 'jquery'
import I18n from 'i18n-js'

// These globals are part of the existing Workplace view contract. Several
// Rails templates and the reCAPTCHA pack use them directly.
window.$ = window.jquery = window.jQuery = $
globalThis.$ = globalThis.jQuery = $
window.I18n = I18n
